module.exports = __webpack_public_path__ + "static/media/wallet.1cc927b2.svg";